export const ROUTES = {
  dashboard: {
    allAssets: '/dashboard/all-assets',
    recentlyUploaded: '/dashboard/recently-uploaded',
    myUploads: '/dashboard/my-uploads',
    recentlyDeleted: '/dashboard/recently-deleted',
    favorites: '/dashboard/favorites',
    board: '/dashboard/board',
    aiAssistant: '/dashboard/ai-assistant'
  },
  profile: {
    prefix: '/profile',
    manageMembers: '/profile/manage-members'
  },
  notFound: '/404',
  home: '/',
}
